<!-- <div class="row justify-content-start">
<div class="col-md-auto">
  <button mat-raised-button color="primary" (click)="regresarConsulta()">Regresar</button>
</div>
</div> -->
<mat-card class="mt-3 mb-2">
  <mat-card-title class="card-title ">
    <app-nav-secciones-complemento
    (recargarDetalleGeneral)="consultarSiniestro(this.siniestroParams.numeroSiniestro, false)"></app-nav-secciones-complemento>
  </mat-card-title>
  <mat-card-content class="contenedor-detalle-siniestro">
    <hr class="mt-1 mb-2">
    <div class="row mt-2 justify-content-between">
      <div class="col-md-auto">
        <span class="titulo-modulo">DATOS DEL <b>SINIESTRO</b></span>
      </div>
      @if (loaderComplemento) {
        <div class="col-md-auto">
          <span class="titulo-modulo">Actualizando... <i class="fas fa-sync fa-spin"></i> </span>
        </div>
      }
      @if (!loaderComplemento) {
        <div class="col-md-auto">
          <span class="titulo-modulo">{{this.siniestroParams.numeroSiniestro}}</span>
        </div>
      }
    </div>
    <hr class="mt-1 mb-2">

    <app-detalle-siniestro-poliza></app-detalle-siniestro-poliza>

    <app-detalle-conductor-siniestro></app-detalle-conductor-siniestro>

    <app-detalle-tabla-coberturas-siniestro></app-detalle-tabla-coberturas-siniestro>

  </mat-card-content>
  <mat-card-actions class="card-actions justify-content-end">
    <div class="row justify-content-end">
      <div class="col-md-auto col-auto">
        <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button (click)="regresarConsulta()">
          Cerrar
        </button>
        <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button
          (click)="abrirModalAccion('CONVENIOS')">
          Convenios
        </button>
        <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button
          (click)="abrirModalAccion('RESUMEN_SINIESTRO')">
          Resumen siniestro
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>